export const fromLocationDTO = ({
    id,
    name,
    holidays,
    closingDays,
    isDefaultLocation,
}) => ({
    id,
    name,
    holidays: holidays.map(h => new Date(h)),
    closingDays: closingDays.map(c => new Date(c)),
    isDefaultLocation,

})

export const fromLocationsDTO = (locations) => locations.map((location) => fromLocationDTO(location))

export const toLocationDTO = (location) => {
    let locationDTO = {
        name: location.name,
        holidays: location.holidays.map(h => h.toISOString().split('T')[0]),
        closingDays: location.closingDays.map(c => c.toISOString().split('T')[0]),
        isDefaultLocation: location.isDefaultLocation,
    }

    if (location.id) {
        locationDTO = {
            ...locationDTO,
            id: location.id
        }
    }

    return locationDTO
}
